// Utility to capitalize the first character of a string safely
export function capitalizeFirst(str) {
  if (typeof str === 'string' && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return '';
}
